import { mockComponent } from 'bloko/common/setupMockComponents';

// eslint-disable-next-line react/display-name
export default mockComponent('Radio', null, {
    withChildren: true,
    // eslint-disable-next-line react/display-name
    innerDependence: ({ children, invalid, innerRef, labelProps, wrapperProps, source, ...radioProps }) => {
        return <input type="radio" {...radioProps} />;
    },
});
